module.exports = __webpack_public_path__ + "static/media/loction-icon.46d6f66b.png";